import { AuthEffects } from './auth.effects'
import { UserEffects } from './user.effects'

export * from './auth.effects'
export * from './user.effects'

export const effects: any[] = [AuthEffects, UserEffects]




// WEBPACK FOOTER //
// ./src/app/shared/auth/store/effects/index.ts